import { render } from "./PaymentsAccounts.vue?vue&type=template&id=213c81ea"
import script from "./PaymentsAccounts.vue?vue&type=script&lang=js"
export * from "./PaymentsAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__